import { useSuspenseQuery } from '@tanstack/react-query'
import { useDeferredValue } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { NestedReportPending } from './-components/shared/nested-report-pending'
import { Evaluation } from './-components/shared/evaluation'

export const Route = createFileRoute('/_app/teams/$teamId/evaluation')({
  component: RouteComponent,
  pendingComponent: NestedReportPending,
  // Shown immediately: at the router's default pendingMs the NAV STACK cannot push while the loaders run,
  // because the level it would push is the route being rendered — see the full story in jobs.$jobId.report.
  pendingMs: 0,
  pendingMinMs: 0,
})

function RouteComponent() {
  const { teamId } = Route.useParams()
  // The layout above declares and warms this; deferring the OBJECT (stable per match) keeps the
  // previous team on screen while a filter/type change loads.
  const context = Route.useRouteContext()
  const deferredTeam = useDeferredValue(context.teamQueryOptions)
  const { data: team } = useSuspenseQuery(deferredTeam)

  // Convert member IDs from number to string to match Member interface
  const members = (team?.members ?? []).map((member) => ({
    ...member,
    id: member.id.toString(),
    evaluations: member.evaluations.map((e) => ({
      ...e,
      memberId: e.memberId,
    })),
  }))

  return <Evaluation teamId={teamId} members={members} data={team?.evaluationMatrix} />
}
